import React from "react";

interface EditZoneModalProps {
  initialData: { description: string; name: string };
  onClose: () => void;
  onSubmit: (data: { description: string; name: string }) => void;
  open: boolean;
}

const EditZoneModal: React.FC<EditZoneModalProps> = ({
  initialData,
  onClose,
  onSubmit,
  open,
}) => {
  const [name, setName] = React.useState(initialData.name);
  const [description, setDescription] = React.useState(initialData.description);

  React.useEffect(() => {
    if (open) {
      setName(initialData.name);
      setDescription(initialData.description);
    }
  }, [open, initialData]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
          Edit Service Zone
        </h2>
        {/* Form fields */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({ description, name });
          }}
        >
          <input
            className="mb-2 w-full rounded border p-2 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
            onChange={(e) => setName(e.target.value)}
            placeholder="Zone Name"
            required
            value={name}
          />
          <input
            className="mb-2 w-full rounded border p-2 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Coverage (Description)"
            required
            value={description}
          />
          <div className="mt-4 flex justify-end gap-2">
            <button
              className="rounded bg-gray-200 px-4 py-2 text-gray-700 dark:bg-gray-700 dark:text-gray-200"
              onClick={onClose}
              type="button"
            >
              Cancel
            </button>
            <button
              className="rounded bg-blue-600 px-4 py-2 text-white dark:bg-blue-500"
              type="submit"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditZoneModal;
